module.exports = __webpack_public_path__ + "img/sumary_current_electric.5cd76eb4.svg";